module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "searchable-select",
    on: {
      "keydown": [function($event) {
        if (_vm._k($event.keyCode, "down", 40)) { return; }
        $event.preventDefault();
        _vm.move(1)
      }, function($event) {
        if (_vm._k($event.keyCode, "up", 38)) { return; }
        $event.preventDefault();
        _vm.move(-1)
      }, function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        $event.preventDefault();
        _vm.choose(_vm.highlighted)
      }, function($event) {
        if (_vm._k($event.keyCode, "esc", 27)) { return; }
        _vm.close($event)
      }]
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm._s(_vm.query)
    },
    on: {
      "focus": function($event) {
        _vm.open = true
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }, function($event) {
        _vm.open = true;
        _vm.highlight = 0
      }]
    }
  }), _vm._v(" "), (_vm.open && _vm.rows.length) ? _c('ul', {
    staticClass: "ss-list"
  }, _vm._l((_vm.rows), function(row, i) {
    return _c('li', {
      key: _vm.rowKey(row) + '-' + i,
      class: {
        'ss-active': i === _vm.highlight
      },
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
          _vm.choose(row)
        },
        "mouseover": function($event) {
          _vm.highlight = i
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.rowLabelFn(row)) + "\n    ")])
  })) : _vm._e(), _vm._v(" "), (_vm.open && !_vm.rows.length) ? _c('div', {
    staticClass: "ss-empty"
  }, [_vm._v("\n    No matches\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1bb071f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/SearchableSelect.vue
// module id = 486
// module chunks = 1